import { GET, POST } from '../../../redux/middleware/types'
import integrationRequest from '../../../services/api/integrationRequest'
import { JiraIssueComponent, JiraServiceDeskRequest, JiraServicedeskRequestType, ServiceDeskResponse } from '../types'
import jiraEndpoints from '../api/jiraEndpoints'

export const fetchJiraComponents = async () => {
  return integrationRequest<JiraIssueComponent[]>({
    method: GET,
    url: jiraEndpoints.components
  })
}

export const fetchJiraRequestTypes = async () => {
  return integrationRequest<ServiceDeskResponse<JiraServicedeskRequestType>>({
    method: GET,
    url: jiraEndpoints.requestTypes
  })
}

export const createJiraRequest = async (data: FormData) => {
  return integrationRequest<JiraServiceDeskRequest>({
    method: POST,
    url: jiraEndpoints.request,
    data
  })
}
